import { Clock } from "lucide-react";
import { Empty, fmtDateTime } from "./shared";

export default function TimelinePane({ timeline }) {
  return (
    <div data-testid="af-timeline">
      <h2 className="font-display font-bold uppercase tracking-tight text-2xl mb-6">Activity Timeline</h2>
      {timeline.length === 0 ? <Empty testid="af-timeline-empty">No activity yet.</Empty> : (
        <div className="relative pl-6 space-y-5" data-testid="af-timeline-list">
          <div className="absolute left-[7px] top-1 bottom-1 w-px bg-white/10" />
          {timeline.map((ev) => (
            <div key={ev.id} data-testid={`af-timeline-${ev.id}`} className="relative">
              <div className="absolute -left-[22px] top-1 h-3.5 w-3.5 rounded-full border-2 border-white bg-black" />
              <p className="text-white/85 text-sm">{ev.text}</p>
              <p className="flex items-center gap-1.5 text-white/35 text-xs mt-0.5"><Clock size={11} /> {fmtDateTime(ev.created_at)}{ev.actor ? ` · ${ev.actor}` : ""}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
